<template>
  <div class="tab-table p-2">
    <div class="row">
      <div class="col-md-4">
        <balance-view-card :customer="customer" :title="$t('Overview')"/>
        <div class="card mt-3 mb-3">
          <div class="card-body d-flex align-items-center">
            <b-form-group class="mb-0">
              <b-form-checkbox
                  :checked="customer.skip_auction_deposit_requirement"
                  size="lg"
                  switch
                  :disabled="!$hasPermission('change_customer')"
                  @change="onDepositRequirementChange">
                <h5 class="d-inline-block mb-0">
                  {{ $t('Exempt from Deposit') }}
                </h5>
              </b-form-checkbox>
            </b-form-group>
          </div>
        </div>
      </div>
      <div class="col-md-8">
        <div class="card">
          <div class="card-header">
            <h5 class="d-inline-block mb-0">
              {{ $t('Reservations') }}
            </h5>
            <b-button v-permission="'change_customer'" class="float-right p-0" variant="link"
                      @click="onNewReservationClick(true)">
              <font-awesome-icon icon="plus" style="font-size: .9em"></font-awesome-icon>
              {{ $t('Add New') }}
            </b-button>
          </div>
          <div class="card-body pt-0 pb-0">
            <artisio-table :items="data" :fields="tableFields" :index="false" :busy="loading">
              <template slot="cell(sale_no)" slot-scope="{item: reservation}">
                <router-link v-if="reservation.auction && !enableContinuousAuction" v-permission="'view_auction'"
                             :to="{ name: 'sales.view', params: { id: reservation.auction.uuid }}">
                  {{ reservation.auction.sale_no }}
                </router-link>
                <span v-else-if="reservation.auction && enableContinuousAuction">
                  {{ reservation.auction.sale_no }}
                </span>
                <live-sale-ref v-if="reservation.auction.live_reference"
                               :href="reservation.auction.live_url" :label="reservation.auction.live_reference"/>
              </template>
              <template slot="cell(amount)" slot-scope="{item: reservation}">
                {{ reservation.amount | asCurrency(reservation.currency.symbol) }}
              </template>
              <template slot="cell(actions)" slot-scope="{item: reservation}">
                <b-tooltip :target="`reservation-edit-btn-${reservation.uuid}`" :title="$t('Edit Reservation')"/>
                <b-button :id="`reservation-edit-btn-${reservation.uuid}`"
                          variant="primary" size="sm" class="mr-2" @click="onReservationEditClick(reservation)">
                  <font-awesome-icon icon="pen"></font-awesome-icon>
                </b-button>
                <b-tooltip :target="`reservation-delete-btn-${reservation.uuid}`" :title="$t('Delete Reservation')"/>
                <b-button :id="`reservation-delete-btn-${reservation.uuid}`"
                          variant="danger" size="sm" class="mr-2" @click="onReservationDeleteClick(reservation)">
                  <font-awesome-icon icon="trash" class="icon"/>
                </b-button>
              </template>
            </artisio-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import BalanceViewCard from "./BalanceViewCard";
  import ArtisioTable from "../../../../core/components/ams-table/ArtisioTable";
  import {SOURCE_CUSTOMER_BALANCE_PAGE} from "../../../constants";
  import LiveSaleRef from "@/core/components/common/LiveSaleRef";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');
  const {mapActions: mapCustomerActions} = createNamespacedHelpers('customer');
  const {mapState: mapGlobalState} = createNamespacedHelpers('global');

  export default {
    name: "BalanceView",
    components: {LiveSaleRef, ArtisioTable, BalanceViewCard},
    data() {
      return {
        tableFields: [
          {key: "sale_no", label: this.$i18n.t('Sale'), sortable: false},
          {key: "amount", label: this.$i18n.t('Amount'), sortable: false},
          {key: "currency_code", label: this.$i18n.t('Currency'), sortable: false},
          {key: "actions", label: this.$i18n.t('Actions'), sortable: false},
        ]
      }
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
        data: state => state.balanceData.reservations.data,
        loading: state => state.balanceData.reservations.loading,
      }),
      ...mapGlobalState(['enableContinuousAuction']),
    },
    methods: {
      ...mapActions(['getCustomerReservations', 'deleteCustomerReservation', 'showCustomerReservationModal']),
      ...mapCustomerActions(['updateCustomer']),
      onNewReservationClick() {
        this.showCustomerReservationModal({source: SOURCE_CUSTOMER_BALANCE_PAGE})
      },
      onReservationEditClick(reservation) {
        this.showCustomerReservationModal({
          source: SOURCE_CUSTOMER_BALANCE_PAGE,
          object: reservation
        });
      },
      async onReservationDeleteClick(reservation) {
        await this.$confirm(
            this.$i18n.t("Are you sure you want to delete following reservation?"),
            this.$i18n.t('Reservation was successfully deleted'),
            this.deleteCustomerReservation,
            reservation.uuid,
        );
      },
      async onDepositRequirementChange(checked) {
        const {success} = await this.updateCustomer({
          ...this.customer,
          skip_auction_deposit_requirement: checked
        })
        if (success) {
          this.$toast('success', this.$t('Deposit Requirement was successfully saved'));
        } else {
          this.$toast('danger', this.$t('Deposit Requirement could not save'));
        }
      },
    },
    async beforeMount() {
      await this.getCustomerReservations();
    }
  }
</script>

<style lang="scss" scoped>
</style>
